const ROADMAP_URL = 'https://airtable.com/embed/appVUW3K58l9B61CZ/shrH0AgAjrsMGidQq';

const ProductRoadmap = () => {
    return (
        <div className="card-wrapper" style={{ height: '80vh' }}>
            <iframe src={ROADMAP_URL} title="Product Roadmap" style={{ width: '100%', height: '100%', border: 'none' }} />
        </div>
    );
};

export default ProductRoadmap;
